import React from "react";
import { Stack, Option, Tooltip } from "@mui/joy";
import DarkInput from "../../common/DarkInput";
import DarkSelect from "../../common/DarkSelect";
import type {
  EquipmentModel,
  AttributeType,
  EquipmentAttributeDefinition,
} from "../../../api/equipment/Equipment.typed";
import { SCreate } from "../../../styles/StyledMUI";
import DarkTypography from "../../common/DarkTypography";
import IconButtonCTA from "../../common/IconButtonCTA";
import { colorTokens, withAlpha } from "../../../styles/globalStyles";

interface EquipmentAttributeFormProps {
  model: EquipmentModel;
  onModelChange: (model: EquipmentModel) => void;
}

export default function EquipmentAttributeForm({
  model,
  onModelChange,
}: EquipmentAttributeFormProps) {
  const [attrLabel, setAttrLabel] = React.useState("");
  const [attrType, setAttrType] = React.useState("string");

  const resetAttrFields = () => {
    setAttrLabel("");
    setAttrType("string");
  };

  const addAttribute = () => {
    if (!attrLabel.trim()) return;
    const newAttr = {
      ID: crypto.randomUUID(),
      Label: attrLabel.trim(),
      Type: attrType as AttributeType,
    };
    if (attrType === "date") {
      (newAttr as EquipmentAttributeDefinition).Alert = { BeforeMonths: 0, AfterMonths: 0 };
    }
    const updated = { ...model, Attributes: [...(model.Attributes || []), newAttr] };
    onModelChange(updated);
    resetAttrFields();
  };

  return (
    <>
      <DarkTypography level="body-md" colorVariant="muted" sx={{ mt: 1 }}>
        Ajouter un attribut
      </DarkTypography>
      <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
        <DarkInput
          placeholder="Libellé"
          value={attrLabel}
          onChange={(e) => setAttrLabel(e.target.value)}
          sx={{ flexGrow: 1 }}
        />
        <DarkSelect
          value={attrType}
          onChange={(_, v) => setAttrType(v as string)}
          sx={{ width: 140 }}
        >
          <Option value="string">Texte</Option>
          <Option value="number">Nombre</Option>
          <Option value="date">Date</Option>
          <Option value="list">Liste</Option>
          <Option value="comments">Commentaires</Option>
        </DarkSelect>
        <Tooltip title="Ajouter">
          <IconButtonCTA
            ctaVariant="success"
            aria-label="Ajouter attribut"
            variant="plain"
            onClick={addAttribute}
            sx={{
              color: colorTokens.status.success,
              "&:hover": { backgroundColor: withAlpha(colorTokens.status.success, 0.1) },
            }}
          >
            <SCreate />
          </IconButtonCTA>
        </Tooltip>
      </Stack>
    </>
  );
}
